import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type InvoiceDrawerSummaryProps = {
  summary?: string;
  fromEmail?: string;
  onMarkAsPaid: () => void;
};

export const InvoiceDrawerSummary = ({ summary, fromEmail, onMarkAsPaid }: InvoiceDrawerSummaryProps) => {
  return (
    <Stack space={3} className="rounded-lg border-[0.5px] border-border bg-white p-4">
      {summary && (
        <Stack space={1}>
          <h3 className="text-sm leading-6 font-medium tracking-tight text-black">Invoice Summary</h3>

          <p className="text-xs leading-6 font-normal tracking-tight text-pretty text-muted-foreground">{summary}</p>
        </Stack>
      )}

      {fromEmail && (
        <Inline justify="between" wrap="nowrap" className="w-full">
          <p className="text-sm leading-6 font-medium tracking-tight text-muted-foreground">Received from</p>

          <p className="w-1/2 overflow-clip text-right text-sm leading-6 font-medium tracking-tight text-ellipsis text-black">
            {fromEmail}
          </p>
        </Inline>
      )}

      <Button variant="link" className="p-0 text-link" onClick={onMarkAsPaid}>
        Already paid this invoice?
      </Button>
    </Stack>
  );
};
